import { Component } from '@angular/core';
import {PortalSetupMenuItems} from '@constants/administration/portal-setup/portal-setup-menu-items';

@Component({
    selector: 'scitis-portal-setup',
    templateUrl: './portal-setup.component.html',
    styleUrls: ['./portal-setup.component.scss'],
    standalone: false
})
export class PortalSetupComponent{

  public show: PortalSetupMenuItems = PortalSetupMenuItems.MACHINE_CATEGORIES;
  public menuItems = PortalSetupMenuItems;

  constructor() { }

  public onMenuClick(menuItem: PortalSetupMenuItems) {
    this.show = menuItem;
  }
}
